import BookFreeClassBtn from '@components/common/book-free-class-btn'
import { Quotation, Stars } from '@components/common/icons/custom-icons'
import { FastlyImage } from '@components/common/image'
import { TESTIMONIAL } from '@lib/data/course-landing-page'
import { CourseNameType } from '@lib/types/course-landing-page'

const IMAGE_PATH = '/images/courses/'

type Props = {
  courseName: CourseNameType
  heading?: string
  urlQuery?: string
}

const TestimonialsFold = ({ courseName, heading, urlQuery }: Props) => {
  const testimonialData = TESTIMONIAL[courseName]

  return (
    <>
      <div className="my-10 lg:px-3 py-5 flex flex-col text-grey">
        <h2 className="text-2xl font-600 mb-6 leading-tight">
          {heading && heading}
          {!heading &&
            `Codingal’s ${testimonialData.courseName} course is loved by students
          and trusted by parents`}
        </h2>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 w-full">
          {testimonialData.testimonials.map((testimonial) => (
            <div
              key={testimonial.name}
              className="relative px-4 py-8 rounded-md shadow-lg text-grey bg-white"
            >
              <div className="flex items-center space-x-3">
                <div className="absolute top-0 left-0 w-8 mt-2 ml-2">
                  <Quotation />
                </div>
                <div>
                  <FastlyImage
                    src={`${testimonialData.path ?? IMAGE_PATH}${
                      testimonial.image
                    }.png`}
                    alt={testimonial.name}
                    width={91}
                    height={104}
                  />
                </div>
                <div className="flex flex-col">
                  <span className="text-xl capitalize font-700">
                    {testimonial.name}
                  </span>
                  {testimonial.profession && (
                    <p className="text-orange">{testimonial.profession}</p>
                  )}
                  <span
                    className="text-sm inline-block px-2 rounded-md text-grey mb-1"
                    style={{ backgroundColor: '#E0E3FD' }}
                  >
                    {testimonial.subheading}
                  </span>
                  <Stars />
                </div>
              </div>
              <span className="inline-block w-full h-1 border-b border-grey-300"></span>

              <p className="pt-6 text-lg leading-tight font-600">
                {testimonial.content}
              </p>
            </div>
          ))}
        </div>

        <div className="mx-auto w-full md:max-w-xs mt-12 text-center">
          <BookFreeClassBtn query={urlQuery} />
        </div>
      </div>
    </>
  )
}
export default TestimonialsFold
